import { useCallback, useEffect, useState } from "react";

// Coordonnées par île. Le site couvre Mayotte et La Réunion ; le visiteur choisit
// son île (ou arrive avec ?ile=reunion / ?ile=mayotte, utile pour les campagnes).
export const ISLANDS = {
  mayotte: {
    label: "Mayotte", city: "Koungou",
    address: ["9 rue Attoumani Oili", "97600 KOUNGOU"],
    phone: "06 39 62 85 88", tel: "+262639628588", whatsapp: "262639628588",
  },
  reunion: {
    label: "La Réunion", city: "Saint-Leu",
    address: ["27 avenue des Artisans", "97436 SAINT-LEU"],
    phone: "06 93 39 74 64", tel: "+262693397464", whatsapp: "262693397464",
  },
};

const STORAGE_KEY = "ep_island";
const EVENT = "ep-island-change";
const WHATSAPP_TEXT = "Bonjour%20Easy%20Pi%C3%A8ces%2C%20je%20recherche%20une%20pi%C3%A8ce%20pour%20mon%20v%C3%A9hicule%20ou%20engin.";

export const whatsappUrl = (island) => `https://wa.me/${ISLANDS[island].whatsapp}?text=${WHATSAPP_TEXT}`;

export function islandFromSearch(search) {
  const value = new URLSearchParams(search || "").get("ile");
  return ISLANDS[value] ? value : "";
}

function readStored() {
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    return ISLANDS[value] ? value : "";
  } catch {
    return "";
  }
}

export function initialIsland() {
  if (typeof window === "undefined") return "";
  return islandFromSearch(window.location.search) || readStored();
}

/** Île choisie, partagée entre l'en-tête et la page (mémorisée dans ce navigateur). */
export function useIsland() {
  const [island, setIslandState] = useState(initialIsland);
  useEffect(() => {
    const onChange = (event) => setIslandState(event.detail || "");
    window.addEventListener(EVENT, onChange);
    return () => window.removeEventListener(EVENT, onChange);
  }, []);
  const setIsland = useCallback((value) => {
    const next = ISLANDS[value] ? value : "";
    try {
      if (next) window.localStorage.setItem(STORAGE_KEY, next);
      else window.localStorage.removeItem(STORAGE_KEY);
    } catch { /* stockage indisponible : le choix reste valable pour la page */ }
    window.dispatchEvent(new CustomEvent(EVENT, { detail: next }));
  }, []);
  return [island, setIsland];
}
